export default () => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: '操作',
    headerAlign: 'center',
    align: 'left',
    width: 110,
    fixed: 'left',
    slots: {
      default: 'opt',
    },
  },
  {
    headerAlign: 'center',
    field: 'custNo',
    align: 'center',
    width: 140,
    title: '客户编号',
    fixed: 'left',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'custName',
    align: 'left',
    width: 120,
    title: '客户名称',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  {
    headerAlign: 'center',
    field: 'custShortName',
    align: 'left',
    width: 120,
    title: '客户简称',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  {
    headerAlign: 'center',
    field: 'customerType',
    align: 'center',
    width: 100,
    title: '客户类型',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  {
    headerAlign: 'center',
    field: 'businessLicense',
    align: 'left',
    width: 150,
    title: '营业执照号',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'establishmentDate',
    align: 'center',
    width: 160,
    title: '成立日期',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
  {
    headerAlign: 'center',
    field: 'legalRepresentative',
    align: 'left',
    width: 120,
    title: '法定代表人',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
  {
    headerAlign: 'center',
    field: 'registeredCapital',
    align: 'left',
    width: 100,
    title: '注册资金',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'depositBank',
    align: 'left',
    width: 220,
    title: '开户银行',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
  {
    headerAlign: 'center',
    field: 'businessAddress',
    align: 'left',
    width: 280,
    title: '经营地址',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'phoneNo',
    align: 'left',
    width: 150,
    title: '固定电话',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'custStatusName',
    align: 'center',
    width: 100,
    title: '状态',
    slots: { default: 'status' },
  },
  {
    headerAlign: 'center',
    field: 'createByName',
    title: '创建人',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'createTime',
    title: '创建时间',
    width: 170,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
  {
    headerAlign: 'center',
    field: 'modifyByName',
    title: '修改人',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'modifyTime',
    title: '修改时间',
    width: 170,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
]
